import { ACTIVITY_SECTIONS } from 'constants/enums'
import { COLORS } from 'constants/layout/section-colors'

export default function(activitySection) {
  if (activitySection === ACTIVITY_SECTIONS.skill.id) {
    return COLORS.blue.value
  } else if (activitySection === ACTIVITY_SECTIONS.service.id) {
    return COLORS.pink.value
  } else if (activitySection === ACTIVITY_SECTIONS.physical_recreation.id) {
    return COLORS.amber.value
  } else if (activitySection === ACTIVITY_SECTIONS.adventurous_journey.id) {
    return COLORS.green.value
  } else if (activitySection === ACTIVITY_SECTIONS.residential_project.id) {
    return COLORS.purple.value
  }
  return 'none'
}
